import type { FormRowProps } from './formMapTypes';
import { groupFormRowMapper } from './formMapHelpers';
import { CustomForm } from './formMapTypes';

const PURCHASE_INVENTORY_GROUP_LENGTH = 7;
const PURCHASE_INVENTORY_SKIPPED_FIELDS_LENGTH = 2;

export const formRowMap: Dictionary<(row: FormRowProps) => FormRowProps[]> = {
  [CustomForm.PURCHASE_INVENTORY]: row =>
    groupFormRowMapper(row, PURCHASE_INVENTORY_GROUP_LENGTH, PURCHASE_INVENTORY_SKIPPED_FIELDS_LENGTH),
};
